const SubmissionPages = () => import('./pages/SubmissionPages.vue');
const VATSubmissions = () => import('./pages/SubmissionPages/VATSubmissions.vue');

const pages = [
    {
        path: "/",
        redirect: "/submissions",
    },
    {
        path: "/submissions",
        name: "Submissions",
        component: SubmissionPages,
        children: [
            {
                path: "",
                redirect: "/submissions/vat-submissions",
            },
            {
                path: "vat-submissions",
                name: "VATSubmissions",
                component: VATSubmissions,
            },
        ],
    },
];

export { pages };
